(() => {
  window.swinger = window.swinger || {};
  window.swinger.focusableElements = [
    'iframe',
    'input:not([type="hidden"])',
    'select',
    'textarea',
    'button',
    'a',
    '[contenteditable]',
    '[tabindex]:not([tabindex="-1"])',
  ];
})();
